import { V2Balance, V2BalanceType } from '@/core/migrate';
import {
  Address,
  Network,
  getChainConstant,
  gql,
  querySubgraph,
} from 'nftx.js';

const TOKEN_BALANCE_SUBGRAPH = {
  [Network.Mainnet]: 'https://g.nftx.xyz/nftx-v2-token-holdings/eth-mainnet',
  // FIXME: move over to the hosted url once it's been deployed
  [Network.Arbitrum]:
    'https://g.nftx.xyz/nftx-v2-token-holdings/arbirum-mainnet',
};

const isDefined = <T>(x: T | undefined): x is T => x != null;

type Response = {
  account: {
    ERC20balances: Array<{
      contract: {
        id: string;
        name: string;
        symbol: string;
        asVaultAsset: {
          type: string;
          vaultId: string;
        };
      };
      valueExact: string;
    }>;
  };
};

const fetchV2Balances = async ({
  network,
  userAddress,
}: {
  network: number;
  userAddress: Address;
}) => {
  const query = gql<Response>`
    {
      account(id: $userAddress) {
        ERC20balances(first: 1000) {
          contract {
            id
            name
            symbol
            asVaultAsset {
              type
              vaultId
            }
          }
          valueExact
        }
      }
    }
  `;

  const data = await querySubgraph({
    url: getChainConstant(TOKEN_BALANCE_SUBGRAPH, network),
    query,
    variables: { userAddress },
  });

  const erc20Balances = data?.account?.ERC20balances ?? [];

  const balances = erc20Balances
    .map(({ contract, valueExact }): V2Balance | undefined => {
      if (valueExact === '0') {
        return;
      }
      const balance = BigInt(valueExact);

      return {
        type: contract.asVaultAsset.type as V2BalanceType,
        vaultId: contract.asVaultAsset.vaultId,
        symbol: contract.symbol,
        name: contract.name,
        balance,
        address: contract.id as Address,
      };
    })
    .filter(isDefined);

  return balances;
};

export default fetchV2Balances;
